import React from 'react';
import { MessageCircle, ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';

const WHATSAPP_NUMBER = "5565992258000";
const WHATSAPP_MESSAGE = "Olá! Gostaria de solicitar um orçamento para climatização.";

export const CTA = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`, '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('orcamento')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="cta-section"
      className="py-20 lg:py-32 cta-gradient relative overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-sky-500 rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-sky-400 rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* Heading */}
        <h2
          className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6"
          data-testid="cta-headline"
        >
          Pronto para otimizar a climatização da sua empresa?
        </h2>

        {/* Subtext */}
        <p
          className="font-manrope text-lg text-white/80 leading-relaxed mb-10 max-w-2xl mx-auto"
          data-testid="cta-subtext"
        >
          Entre em contato com nossa equipe e receba um atendimento personalizado 
          para encontrar a melhor solução em climatização para o seu negócio.
        </p>

        {/* CTA Buttons */}
        <div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          data-testid="cta-buttons"
        >
          <Button
            onClick={handleWhatsApp}
            className="bg-white hover:bg-slate-100 text-slate-900 font-semibold rounded-full px-8 py-4 text-base transition-all shadow-xl hover:shadow-2xl"
            data-testid="cta-whatsapp-button"
          >
            <MessageCircle className="w-5 h-5 mr-2 text-green-500" />
            Falar no WhatsApp
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>

          <Button
            onClick={scrollToContact}
            variant="outline"
            className="bg-transparent hover:bg-white/10 text-white font-semibold rounded-full px-8 py-4 text-base transition-all border-2 border-white/30 hover:border-white/50"
            data-testid="cta-orcamento-button"
          >
            <Phone className="w-5 h-5 mr-2" />
            Solicitar Orçamento
          </Button>
        </div>

        {/* Trust Text */}
        <p
          className="font-manrope text-sm text-white/60 mt-8"
          data-testid="cta-trust-text"
        >
          Atendimento em Cuiabá e região • Resposta em até 24 horas úteis
        </p>
      </div>
    </section>
  );
};
